import { Grid, Paper, Button } from "@mui/material";
import { InsertPhoto, ContactMail, CreditCard } from "@mui/icons-material";
import CustomTextField from "../../components/Custom/CustomTextField";
import placeholder from "../../assets/svg/placeholder.svg";

const KYCFields = ({
  profileData,
  handleChange,
  handleImageUpload,
  previews,
  t,
  errors,
}) => {
  return (
    <>
      <Grid item xs={12}>
        <CustomTextField
          label={t("Aadhar Number")}
          value={profileData.kyc_details.aadhar_number || ""}
          name="kyc_details.aadhar_number"
          onChange={handleChange}
          error={!!errors["kyc_details.aadhar_number"]}
          helperText={errors["kyc_details.aadhar_number"]}
        />
        <Paper
          elevation={3}
          sx={{
            width: "100%",
            height: 200,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mb: 2,
            mt: 2,
            position: "relative",
          }}
        >
          {previews.aadhar_image ? (
            <img
              src={previews.aadhar_image || placeholder}
              alt="Aadhar Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                padding: "8px",
              }}
            />
          ) : (
            <ContactMail sx={{ fontSize: 80, color: "#ccc" }} />
          )}
        </Paper>
        <input
          id="aadhar-image"
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={(e) => handleImageUpload(e, "aadhar_image")}
        />
        <Button
          variant="outlined"
          component="label"
          htmlFor="aadhar-image"
          fullWidth
          sx={{ color: "#4CAF50" }}
        >
          <InsertPhoto fontSize="medium" sx={{ mr: 2, color: "#4CAF50" }} />
          {t("Upload Aadhar")}
        </Button>
      </Grid>

      <Grid item xs={12}>
        <CustomTextField
          label={t("PAN Number")}
          value={profileData.kyc_details.pan_number || ""}
          name="kyc_details.pan_number"
          onChange={handleChange}
          error={!!errors["kyc_details.pan_number"]}
          helperText={errors["kyc_details.pan_number"]}
        />
        <Paper
          elevation={3}
          sx={{
            width: "100%",
            height: 200,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mb: 2,
            mt: 2,
            position: "relative",
          }}
        >
          {previews.pan_image ? (
            <img
              src={previews.pan_image || placeholder}
              alt="PAN Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                padding: "8px",
              }}
            />
          ) : (
            <CreditCard sx={{ fontSize: 80, color: "#ccc" }} />
          )}
        </Paper>
        <input
          id="pan-image"
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={(e) => handleImageUpload(e, "pan_image")}
        />
        <Button
          variant="outlined"
          component="label"
          htmlFor="pan-image"
          fullWidth
          sx={{ color: "#4CAF50" }}
        >
          <InsertPhoto fontSize="medium" sx={{ mr: 2, color: "#4CAF50" }} />
          {t("Upload PAN")}
        </Button>
      </Grid>
    </>
  );
};

export default KYCFields;
